











import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Tree from './docs-main/tree-view/Tree.vue';
import { Getter } from 'vuex-class';
import { RootTree } from '../templates/Tree';

@Component({
  components: {
    Tree,
  },
})
export default class DocsSidebar extends Vue {
  @Prop({ default: 'auto', type: String }) minHeight: string;
  @Getter('getTree') treeData: RootTree;
  public showSidebar = true;

  $refs!: {
    docsLayoutSidebar: HTMLElement;
  };

  get sidebarToggleClass() {
    return this.showSidebar ? 'is-collapsed' : 'is-expanded';
  }

  toggleSidebar() {
    this.showSidebar = !this.showSidebar;
  }

  enterSidebar(element: HTMLElement, done: () => void) {
    this.$refs.docsLayoutSidebar.style.width = '100%';
    done();
  }

  afterEnterSidebar() {
    this.$refs.docsLayoutSidebar.style.width = '100%';
  }

  leaveSidebar(elm: HTMLElement, done: () => void) {
    this.$refs.docsLayoutSidebar.style.width = '16px';
    done();
  }
}
